document.addEventListener('DOMContentLoaded', function() {
    class AnimalCrossSell {
      constructor() {
        this.initialized = false;
        this.cartAction = document.querySelector('.animal-cross-sell')?.dataset.cartAction || 'page';
        this.init();
      }
  
      init() {
        if(this.initialized) return;
        document.querySelectorAll('.animal-cross-sell__product').forEach(product => {
          this.initializeProduct(product);
        });
        this.initialized = true;
      }

      initializeProduct(product) {
        const checkbox = product.querySelector('.cross-sell-checkbox');
        const checkboxLabel = checkbox?.nextElementSibling;
        const swatches = product.querySelectorAll('.swatch input[type="radio"]');
        const mainImage = product.querySelector('[data-main-image]');
        
        if (!checkbox || !checkboxLabel) return;

        // Set translation attributes
        checkboxLabel.setAttribute('data-added', window.theme?.cartStrings?.added_to || 'Added to cart');
        checkboxLabel.setAttribute('data-removed', window.theme?.cartStrings?.removed_from || 'Removed from cart');

        // Initialiser l'état de la checkbox
        this.updateCheckboxState(checkbox);

        // Gérer les changements de swatch
        swatches.forEach(swatch => {
          swatch.addEventListener('change', (e) => {
            const value = e.target.value;
            const optionIndex = parseInt(e.target.dataset.optionIndex);
            
            // Mise à jour du titre de la variante
            const variantGroup = e.target.closest('.animal-cross-sell__variant-group');
            if (variantGroup) {
              const variantTitle = variantGroup.querySelector('.selected-variant');
              if (variantTitle) {
                variantTitle.textContent = value;
              }
            }

            // Trouver la bonne variante basée sur toutes les options sélectionnées
            const selectedOptions = Array.from(product.querySelectorAll('.swatch input[type="radio"]:checked')).map(input => ({
              value: input.value,
              index: parseInt(input.dataset.optionIndex)
            }));

            const variantId = this.findVariantId(product, selectedOptions);
            const variant = this.findVariant(product, selectedOptions);
            
            // Mise à jour de l'image si la variante a une image
            if (variant && variant.image && mainImage) {
              mainImage.src = variant.image;
            }
            
            // Mise à jour de la checkbox
            if (checkbox && variantId) {
              checkbox.dataset.variantId = variantId;
              checkbox.checked = false;
            }
          });
        });

        // Gérer les changements de checkbox
        checkbox.addEventListener('change', async (e) => {
          const variantId = e.target.dataset.variantId;
          if(!variantId || isNaN(parseInt(variantId, 10))) {
            e.target.checked = false;
            return;
          }

          e.target.disabled = true;
          const notificationWrapper = checkboxLabel.querySelector('.cross-sell-notifications');
          
          try {
            if(e.target.checked) {
              await this.addToCart(variantId);
              // Show "added" notification
              notificationWrapper.classList.add('just-added');
              notificationWrapper.querySelector('.cross-sell-notification--added').classList.add('is-visible');
              setTimeout(() => {
                notificationWrapper.classList.remove('just-added');
                notificationWrapper.querySelector('.cross-sell-notification--added').classList.remove('is-visible');
              }, 2000);
            } else {
              await this.removeFromCart(variantId);
              // Show "removed" notification
              notificationWrapper.classList.add('just-removed');
              notificationWrapper.querySelector('.cross-sell-notification--removed').classList.add('is-visible');
              setTimeout(() => {
                notificationWrapper.classList.remove('just-removed');
                notificationWrapper.querySelector('.cross-sell-notification--removed').classList.remove('is-visible');
              }, 2000);
            }
          } catch (error) {
            console.error('Cart operation failed:', error);
            e.target.checked = !e.target.checked;
          } finally {
            e.target.disabled = false;
          }
        });
      }

      findVariant(product, selectedOptions) {
        const variantsJson = product.querySelector('script[data-variants-json]');
        if (!variantsJson) return null;

        try {
          const variants = JSON.parse(variantsJson.textContent);
          return variants.find(variant => {
            return selectedOptions.every(option => variant.options[option.index] === option.value);
          });
        } catch (error) {
          console.error('Error finding variant:', error);
          return null;
        }
      }

      findVariantId(product, selectedOptions) {
        const variant = this.findVariant(product, selectedOptions);
        return variant ? variant.id : null;
      }
  
      async updateCheckboxState(checkbox) {
        try {
          const cart = await (await fetch('/cart.js')).json();
          const variantId = checkbox.dataset.variantId;
          const isInCart = cart.items.some(item => item.variant_id.toString() === variantId.toString());
          checkbox.checked = isInCart;
        } catch (error) {
          console.error('Error updating checkbox state:', error);
        }
      }
  
      async addToCart(variantId) {
        const id = parseInt(variantId, 10);
        if (isNaN(id)) throw new Error('Invalid variant ID: ' + variantId);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ 
              id: id,
              quantity: 1,
              properties: { '_cross_sell': 'true' }
            }]
          })
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add to cart');
        }
        
        await this.updateCartUI();
      }
  
      async removeFromCart(variantId) {
        const cart = await (await fetch('/cart.js')).json();
        const itemToRemove = cart.items.find(item => item.variant_id.toString() === variantId.toString());
        
        if (!itemToRemove) return;

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemToRemove.key,
            quantity: 0
          })
        });

        if (!response.ok) throw new Error('Failed to remove from cart');
        
        await this.updateCartUI();
      }
  
      async updateCartUI() {
        try {
          const cartData = await (await fetch('/cart.js')).json();
          
          if (this.cartAction === 'drawer') {
            if (window.wetheme?.cartDrawer) {
              await window.wetheme.cartDrawer.updateCartDrawer(cartData);
              
              const drawerCart = document.querySelector('.drawer--cart');
              if (drawerCart?.open) {
                drawerCart.open();
              } else {
                const cartDrawerTrigger = document.querySelector('[data-drawer-trigger="cart-drawer"]');
                if (cartDrawerTrigger) {
                  cartDrawerTrigger.click();
                }
              }
            } else {
              window.location.reload();
            }
          } else {
            window.location.reload();
          }
        } catch (error) {
          console.error('Error updating cart UI:', error);
          window.location.reload();
        }
      }
    }
  
    // Initialiser une seule instance
    window.AnimalCrossSell = new AnimalCrossSell();
});
  